import type { FunctionComponent } from "react";

import { Avatar } from "scmp-app/components/avatar";
import { DashboardWidget } from "scmp-app/scmp-sdk/components/dashboard-widget";

type HeaderAvatarProps = {
  className?: string;
};

export const HeaderAvatar: FunctionComponent<HeaderAvatarProps> = ({ ...props }) => (
  <DashboardWidget {...props}>
    <Avatar />
  </DashboardWidget>
);
